import {
  BarChart3,
  CalendarRange,
  ChartColumnIncreasing,
  CreditCard,
  Download,
  Inbox,
  Landmark,
  List,
  type LucideIcon,
  PiggyBank,
  RefreshCw,
  Settings,
  Sun,
  Users,
  Wallet,
} from 'lucide-react';

export type NavItem = {
  to: string;
  label: string;
  icon: LucideIcon;
  /** Show the inbox counter on this item */
  badge?: 'inbox';
};

/** The everyday screens: bottom tabs on phones, top of the sidebar on desktop */
export const PRIMARY_NAV: NavItem[] = [
  // New purchases are sorted right on Idag, so the counter lives there
  { to: '/', label: 'Idag', icon: Sun, badge: 'inbox' },
  { to: '/transactions', label: 'Köp', icon: List },
  { to: '/plan', label: 'Plan', icon: CalendarRange },
];

/** Everything else, behind "Mer" on phones */
export const SECONDARY_NAV: { label: string; items: NavItem[] }[] = [
  {
    label: 'Översikt',
    items: [
      { to: '/insights', label: 'Insikter', icon: BarChart3 },
      { to: '/savings', label: 'Sparande', icon: PiggyBank },
      { to: '/inbox', label: 'Att sortera', icon: Inbox, badge: 'inbox' },
    ],
  },
  {
    label: 'Fasta kostnader',
    items: [
      { to: '/bills', label: 'Räkningar', icon: CreditCard },
      { to: '/bills/history', label: 'Kostnadshistorik', icon: ChartColumnIncreasing },
      { to: '/loans', label: 'Lån', icon: Landmark },
    ],
  },
  {
    label: 'Bank',
    items: [
      { to: '/open-banking', label: 'Bankkopplingar', icon: Wallet },
      { to: '/activity', label: 'Synklogg', icon: RefreshCw },
      { to: '/import', label: 'Importera CSV', icon: Download },
    ],
  },
  {
    label: 'Konto',
    items: [
      { to: '/household', label: 'Hushåll', icon: Users },
      { to: '/settings', label: 'Inställningar', icon: Settings },
    ],
  },
];

const ALL_NAV_PATHS = [...PRIMARY_NAV, ...SECONDARY_NAV.flatMap((group) => group.items)].map(
  (item) => item.to,
);

function isWithin(currentPath: string, to: string) {
  return currentPath === to || currentPath.startsWith(`${to}/`);
}

export function isActivePath(currentPath: string, to: string) {
  if (to === '/') return currentPath === '/';
  if (!isWithin(currentPath, to)) return false;
  // A nested nav item (e.g. /bills/history under /bills) owns its own subtree
  return !ALL_NAV_PATHS.some((other) => other.startsWith(`${to}/`) && isWithin(currentPath, other));
}
